var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-lg-7"},[_c('div',{attrs:{"id":"safety-terms"},domProps:{"innerHTML":_vm._s(_vm.safetyTerms)}})])])])}
var staticRenderFns = []

export { render, staticRenderFns }